import { Button, Checkbox, FormControlLabel, FormGroup, Paper } from "@mui/material";
import ConsentAgreementLabel from "@entrilia/shared/components/consentAgreement/ConsentAgreementLabel";
import ConsentDialogBody from "@entrilia/shared/components/consentAgreement/ConsentDialogBody";

interface Props {
  logoUrl: string | undefined;
  consentName: string;
  consentContent: string;
  customAgreementText: string | undefined;
}

const UserConsentPreview = ({ logoUrl, consentName, consentContent, customAgreementText }: Props) => {
  return (
    <Paper variant="outlined" sx={{ ".MuiDialogContent-root": { height: "calc(100vh - 352px)", width: "47.5rem" } }}>
      <ConsentDialogBody
        title="Welcome to Investor Portal"
        showTitle
        logoUrl={logoUrl}
        consentContent={consentContent}
        acceptFormGroup={
          <FormGroup sx={{ my: "1rem" }}>
            <FormControlLabel
              control={<Checkbox color="primary" disabled />}
              label={<ConsentAgreementLabel consentName={consentName} customAgreementText={customAgreementText} />}
            />
          </FormGroup>
        }
        saveButton={
          <Button disabled variant="contained" sx={{ height: "2.25rem", width: "7rem" }}>
            Continue
          </Button>
        }
      />
    </Paper>
  );
};

export default UserConsentPreview;
